import { Component, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { CookieService } from 'ngx-cookie';
import { AppService } from '../../app.service';
import { LandingService } from '../landing/landing.service';
import { ErrorService } from '../error/error.service';
import { AccessibilityService } from '../../services/accessibility.service';

declare let $: any;

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html'
})
export class CustomerComponent implements AfterViewInit, OnDestroy {
  private subscription: Subscription;
  public customer;
  private displayCustomerBlock = false;
  private currentTierCode;
  @HostListener('document:click', ['$event.target'])
  onClick(targetElement) {
    if (targetElement.id === 'user-profile' || targetElement.id === 'user-short-name' ||
      targetElement.parentElement.id === 'user-profile') {
      this.toggleCustomer();
    }
    if (targetElement.id === 'buy-wifi-home') {
      this.hideCustomerDashboard();
    }
    if(targetElement.id === 'bg-login-disable') {
      this.toggleCustomer();
    }
  }

  constructor(
    private translate: TranslateService,
    private cookieService: CookieService,
    private appService: AppService,
    private landingService: LandingService,
    private errorService: ErrorService,
    private accessibilityService: AccessibilityService) {
    this.logoutCustomer();
  }

  private onLogInSucess(err: any, response: any) {
    if (!err) {
      const basicProfileString = sessionStorage.getItem('basicProfile');
      if ((JSON.parse(basicProfileString)).currentTierCode) {
        this.currentTierCode = 'profile-' + (JSON.parse(basicProfileString).currentTierCode).toLowerCase();
        $('#landing-terms-user-profile').attr('class', 'icon-profile profile');
        $('#user-profile, #landing-terms-user-profile').addClass(this.currentTierCode);
      }
      if (basicProfileString && basicProfileString != null) {
        const basicProfile = JSON.parse(basicProfileString);
        const shortName = basicProfile.firstName[0] + basicProfile.lastName[0];
        $('#user-short-name, #landing-terms-short-name').text(shortName);
        $('#user-short-name, #landing-terms-short-name').parent().parent().addClass('logged-user');
      }
      const username = response.accountInformation.userName;
      this.appService.setLoggedInUsername(username);
      this.appService.deviceStatusCheckAfterLoginOrLogout();
    }
  }

  private onAccountInfoSucess() {
    const basicProfileString = sessionStorage.getItem('basicProfile');
    if (basicProfileString && basicProfileString != null) {
      const basicProfile = JSON.parse(basicProfileString);
      if (basicProfile.eb === true && basicProfile.points !== undefined) {
        $('#header-user-points').text(`${basicProfile.formattedPoints} ${this.translate.instant('header.points')}`);
      }
      if (basicProfile.currentTierCode !== undefined) {
        const x = basicProfile.currentTierCode.toLowerCase();
        $('#user-profile').addClass('profile-' + x);
      }
    }
  }

  private onLogOutSucess() {
    $('#header-user-points').text('');
    $('#user-short-name').text('');
    $('#user-short-name').parent().parent().removeClass('logged-user');
    $('#user-profile').removeClass(this.currentTierCode);
    this.appService.deviceStatusCheckAfterLoginOrLogout();
  }

  private toggleCustomer() {
    if (!this.displayCustomerBlock) {
      this.accessibilityService.focus('#Loginemail');
      this.customer.show();
      $('#bg-login-disable').attr('style', 'display: block;');
    } else {
      this.customer.hide();
    }
    this.displayCustomerBlock = !this.displayCustomerBlock;
  }

  private hideCustomerDashboard() {
    if (this.displayCustomerBlock) {
      this.customer.hide();
      this.displayCustomerBlock = !this.displayCustomerBlock;
    }
  }

  ngAfterViewInit() {
    this.loadCustomer();
  }

  loadCustomer() {
    this.appService.loadCustJs(this, ()  =>  {
      let customerConfig = {
      lang: this.appService.getLanguage(),
      market: this.appService.getPOS(),
      wifiActivate: false,
      loginCallback: (err: any, response: any) => this.onLogInSucess(err, response),
      logoutCallback: (err: any, response: any) => this.onLogOutSucess(),
      accountInfoCallback: () => this.onAccountInfoSucess(),
      skinCode: true
      }
      this.customer = new (window as any).Customer('#customer', customerConfig)
    });
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    if (this.subscription !== undefined) {
      this.subscription.unsubscribe();
    }
  }

  private logoutCustomer() {
    this.subscription = this.appService.landingCustomerLogoutObservable.subscribe(
      value => {
        if (value) {
          this.customer.logout();
        }
      });
  }
}
